


























































































































import { Component, Vue } from 'vue-property-decorator'

import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import {
  BIconCaretDownFill,
  BIconEnvelope,
  BIconSearch,
  BIconCart3,
  BBadge,
  BRow,
  BCol,
  BButton,
  BNavbar,
  BNavbarToggle,
  BCollapse,
  BNavbarNav,
  BNavItem,
  BNavItemDropdown,
  BDropdownItem,
  BNavForm,
  BFormInput,
  BInputGroup,
  BInputGroupAppend
} from 'bootstrap-vue'

import ProductsApi from '@cms-labs/typescript-api/products'
import { ProductType } from '@cms-labs/typescript-api/products/types'

import { app } from '../main'
import store from '../store'
import LoadingOverlay from '@/components/LoadingOverlay.vue'

@Component({
  components: {
    LoadingOverlay,
    BIconCaretDownFill,
    BIconEnvelope,
    BIconSearch,
    BIconCart3,
    BBadge,
    BRow,
    BCol,
    BNavbar,
    BNavbarToggle,
    BCollapse,
    BNavbarNav,
    BNavItem,
    BNavForm,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    BButton,
    BNavItemDropdown,
    BDropdownItem
  }
})
export default class NavBar extends Vue {
  private navbarShadow = false
  private isLoading = false
  private query: string | null = null
  public productTypes: ProductType[] = []

  public get cartItemsCount () { return store.cart.itemsCount }

  private mounted (): void {
    window.addEventListener('scroll', this.setNavbarShadow)
  }

  private async created (): Promise<void> {
    try {
      this.isLoading = true
      const http = new ProductsApi(app)
      const resp = await http.getProductTypeCollection()
      if (resp) { this.productTypes = resp }
      this.isLoading = false
    } catch (error) { this.isLoading = false }
  }

  private setNavbarShadow () {
    const yPosition = window.pageYOffset || document.documentElement.scrollTop
    this.navbarShadow = yPosition > 19
  }

  private executeSearch () {
    if (this.query !== null) {
      if (this.$route.path === '/q/search') {
        // If in the search endpoint already, update the url Qs and refresh
        // @TODO this generates a console error because it navigates to the
        // current path. Check that /q/search?q={{query}} doesn't match before
        // redirecting to it.
        this.$router.push({ path: '/q/search', query: { q: this.query } })
        this.$router.go(0)
      } else {
        this.$router.push({ path: '/q/search', query: { q: this.query } })
      }
    }
  }
}
